import { render, staticRenderFns } from "./fileadministration.vue?vue&type=template&id=3ab8fa6c&scoped=true&"
import script from "./fileadministration.vue?vue&type=script&lang=js&"
export * from "./fileadministration.vue?vue&type=script&lang=js&"
import style0 from "./fileadministration.vue?vue&type=style&index=0&id=3ab8fa6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8fa6c",
  null
  
)

export default component.exports